
import React, { useRef } from 'react'
import { Canvas } from '@react-three/fiber'

import { OrbitControls, PerspectiveCamera } from "@react-three/drei"

import * as THREE from 'three'
import Lights from './Lights';
import Loader from './Loader';
import { Suspense } from "react";
import CombinedCanvas from './combined';
export const angleToRadians = (angleInDeg) => (Math.PI / 180) * angleInDeg;
const IphoneThreeCanvas = () => {
    const controlRef = useRef()
    return (
        <Canvas>
            <ambientLight intensity={0.3} />

            <PerspectiveCamera makeDefault position={[0, 0, -4.4]} />

            <Lights />

            {/* Ambient light */}
            <ambientLight args={["#ffffff", 0.25]} />

            {/* Spotlight light */}
            <spotLight args={["#000000", 1.5, 7, angleToRadians(45), 0.4]} position={[-3, 1, 0]} castShadow />

            <OrbitControls 
                ref={controlRef}
                makeDefault
                enableZoom={false}
                enablePan={false}
                rotateSpeed={0.4}
                target={new THREE.Vector3(0, 0 ,0)}
                onEnd={(e) => {
                console.log(controlRef.current.getAzimuthalAngle())
                // setRotationState(controlRef.current.getAzimuthalAngle())
                }}
            /> 

            <group name='large' position={[0, 0 ,0]}>

                <Suspense fallback={<Loader />}>
                    <CombinedCanvas/>
                </Suspense>
            </group>
        </Canvas>
    )
}

export default IphoneThreeCanvas

